import React from "react";
import Pikaday from "pikaday";

class P extends React.Component {
    render() {
        return (
            <input
                {...this.props}
                onChange={this.props.onChange}
                ref={r => {
                    if (!this.p) {
                        this.p = new Pikaday({
                            field: r,
                            defaultDate: new Date(),
                            setDefaultDate: true,
                            onSelect: () => {
                                this.props.onChange(this.p.getMoment());
                            }
                        });
                    }
                }}
            />
        );
    }
}

export default P;
